import { render, staticRenderFns } from "./MasterplanStreetsSituationCopyDialog.vue?vue&type=template&id=07886542&"
import script from "./MasterplanStreetsSituationCopyDialog.vue?vue&type=script&lang=js&"
export * from "./MasterplanStreetsSituationCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports